// Utils
import { appendOpacityValueToColour } from '../../../utils/colours';
// Types
import { grey } from '../../colours/styles/greys';
export var coloursWithTransparency = {
    // Modal dialog
    500: appendOpacityValueToColour(grey[800], 50),
};
//# sourceMappingURL=coloursWithTransparency.js.map